import {Modal as ChakraModal, ModalOverlay, UseModalProps} from '@chakra-ui/react';
import React, {PropsWithChildren} from 'react';

export interface IModalProps extends UseModalProps {
  blockScrollOnMount?: boolean;
  scrollBehavior?: boolean;
  fullSize?: boolean;
}

export const Modal: React.FC<PropsWithChildren<IModalProps>> = ({
  closeOnOverlayClick,
  isOpen,
  onClose,
  blockScrollOnMount,
  scrollBehavior,
  children,
  fullSize,
}) => {
  return (
    <ChakraModal
      closeOnOverlayClick={closeOnOverlayClick}
      size={fullSize ? 'full' : undefined}
      isOpen={isOpen}
      onClose={onClose}
      blockScrollOnMount={blockScrollOnMount}
      scrollBehavior={scrollBehavior ? 'inside' : 'outside'}
    >
      <ModalOverlay />
      {children}
    </ChakraModal>
  );
};
